import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import ForgotPassword from '../../../components/forgot-password/forgot-password'

export class ForgotPasswordPage extends Component {
  constructor(props) {
    super()
  }

  render() {
    return (
      <div>
        <ForgotPassword {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(ForgotPasswordPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/forgot-password-page/forgot-password-page.js